<template>
  <div
    @mouseenter="handleMouseHover(true)"
    @mouseleave="handleMouseHover(false)"
  >
    <b-dropdown
      variant="link"
      right
      no-caret
      class="nav-profile"
      ref="nav_profile"
    >
      <template slot="button-content" v-if="user">
        <IconAvatar
          v-if="windowWidth >= 640"
          :name="user.firstName + ' ' + user.lastName"
          :url="user.avatar"
        />
        <img
          v-else
          class="icon-hamburger"
          src="@/assets/media/icons/icon-hamburger.svg"
          alt="icon-hamburger"
        />
      </template>
      <b-dropdown-header
        to="/user/profile"
        class="menu-header"
        v-if="windowWidth < 640"
      >
        <div class="menu-header--content">
          <router-link to="/user" class="navbar-brand">
            <Spinner :theme="primary" v-if="loader" />
            <template v-else>
              <img
                v-if="isDefaultLogo.length && !isDefaultLogo[1].value.status"
                :src="isDefaultLogo[0].value.image"
                style="width: 170px; height: 60px; border-radius: 5px;"
                alt=""
              />
              <img
                v-else
                src="@/assets/media/brand.svg"
                style="width: 170px; height: 60px; border-radius: 5px;"
                alt="QSpace Logo"
              />
            </template>
          </router-link>
          <button class="dropdown-close" @click="closeNavProfile()">
            <img
              class="icon-close"
              src="@/assets/media/icons/icon-close-v2.svg"
              alt="icon-close"
            />
          </button>
        </div>
      </b-dropdown-header>
      <b-dropdown-item
        to="/admin/dashboard"
        class="toggle-role"
        v-if="windowWidth < 640 && isAdmin"
      >
        <img
          class="icon-switch"
          src="@/assets/media/icons/icon-arrow-switch.svg"
          alt="icon-switch"
        />
        <span class="nav-text">Member</span>
      </b-dropdown-item>
      <b-dropdown-item to="/user/profile">
        <IconBase icon-name="Profile">
          <IconUser />
        </IconBase>
        <span class="nav-text">Profile</span>
      </b-dropdown-item>
      <b-dropdown-item to="/user/orders">
        <IconBase icon-name="Bookings">
          <IconCalendarAlt />
        </IconBase>
        <span class="nav-text">Orders</span>
      </b-dropdown-item>
      <b-dropdown-item to="/user/events">
        <IconBase icon-name="Events">
          <IconCalendar />
        </IconBase>
        <span class="nav-text">Events</span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="
          isFeedbackSupportOption.length &&
            isFeedbackSupportOption[0].value.status
        "
        @click="handleFeedbackClick"
      >
        <IconBase icon-name="Feedback">
          <IconFeedback />
        </IconBase>
        <span class="nav-text">Feedback</span>
      </b-dropdown-item>
      <b-dropdown-item @click="signout">
        <IconBase icon-name="Sign out">
          <IconSignout />
        </IconBase>
        <span class="nav-text">Sign Out</span>
      </b-dropdown-item>
    </b-dropdown>
    <UserFeedback v-if="isFeedbackOpened" @close="handleModalClose" />
  </div>
</template>

<script>
import {
  IconUser,
  IconCalendarAlt,
  IconCalendar,
  IconFeedback,
  IconSignout,
  IconAvatar
} from "@/components/icons";
import IconBase from "@/components/IconBase";
import UserFeedback from "@/modules/user/pages/UserFeedback";
import { mapActions } from "vuex";
import _ from "lodash";
import { socketSender } from "@/helpers/socket";
import * as logger from "@/helpers/logger";
import axios from "@/helpers/axios";
import moment from "@/helpers/moment";
import Spinner from "@/components/Spinner";

export default {
  components: {
    IconUser,
    IconCalendarAlt,
    IconCalendar,
    IconFeedback,
    IconSignout,
    IconBase,
    IconAvatar,
    UserFeedback,
    Spinner
  },
  data() {
    return {
      isFeedbackOpened: false,
      isFeedbackSupportOption: {},
      currentUser:
        this.$store.getters.getUser.firstName +
        " " +
        this.$store.getters.getUser.lastName,
      isDefaultLogo: [
        {
          value: {
            image: null
          }
        },
        {
          value: {
            status: false
          }
        }
      ],
      loader: true,
      windowWidth: window.innerWidth
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    isAdmin() {
      const loggedUser = this.$store.getters.getUser;
      if (loggedUser.Roles && loggedUser.Roles.length > 0) {
        const role = loggedUser.Roles.find(role => role.value === 8);
        if (role) return true;
      }

      return false;
    }
  },
  methods: {
    ...mapActions({
      AUTH_UNSET: "AUTH_UNSET"
    }),
    signout() {
      this.AUTH_UNSET()
        .then(() => {
          /**
           * SOCKET: Signout from User Dashboard
           */
          let logContent = `${this.currentUser} signed-out from QSpace User Dashboard`;
          socketSender("userLogout", logContent);
        })
        .then(() => {
          this.$router.push("/");
        })
        .catch(error => {
          logger.error(error);
        });
    },
    handleFeedbackClick() {
      this.isFeedbackOpened = true;
    },
    handleModalClose() {
      this.isFeedbackOpened = false;
    },
    handleMouseHover(param) {
      if (
        !document.querySelectorAll(".nav-profile")[0].classList.contains("show")
      ) {
        document.querySelectorAll(".avatar")[0].style.boxShadow = param
          ? `0 0 0 2px ${this.primary}`
          : "0 0 0 0px #51b67e";
      }
    },
    price(data) {
      const {
        hasStartDate,
        calculatedValue,
        calculatedBy,
        startAt,
        endAt,
        price
      } = data;
      var start = moment(startAt);
      var end = moment(endAt);
      var total;
      if (hasStartDate) {
        total =
          end && start
            ? (end.diff(start, calculatedBy, true) / calculatedValue) * price
            : null;
      } else {
        total = price;
      }
      return total;
    },
    closeNavProfile() {
      this.$refs.nav_profile.hide(true);
    }
  },
  async created() {
    await this.$store.dispatch("fetchOptions", "support");
    let supportFilterFeedback = {
      key: "support.feedback"
    };
    this.isFeedbackSupportOption = _.filter(
      this.options,
      supportFilterFeedback
    );

    await axios
      .get(`orders/${this.user.id}/getOutdatedAmount`)
      .then(async result => {
        var data = {};
        var resultData = [];
        result.data.data.map(el => {
          data = {
            amount: this.price(el),
            id: el.orderPackageId
          };
          resultData.push(data);
        });
        if (resultData.length) {
          await axios.post(`orders/updateOrderAmount`, resultData);
        }
      });

    await this.$store.dispatch("fetchOptions", "defaultlogo");
    this.loader = false;
    this.isDefaultLogo = this.options;
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  }
};
</script>

<style lang="scss">
.nav-profile {
  &.show,
  &:hover {
    .avatar {
      box-shadow: none;
    }
  }

  .icon-hamburger {
    display: block;
    width: 1.4rem;
  }

  .dropdown-close {
    cursor: pointer;
    border: none;
    background-color: transparent;
    margin-right: 20px;

    .icon-close {
      width: 1.2rem;
    }
  }

  .menu-header {
    display: block;

    &--content {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .avatar {
    display: block;
    border-radius: 2.5rem;
    height: 2.5rem;
    width: 2.5rem;
  }

  .btn-link {
    border: 0;
    padding: 0;
  }

  .icon {
    color: $gray-500;
    height: 1.5rem;
    margin-right: 0.5rem;
    width: 1.5rem;
  }

  .nav-text {
    display: inline-block;
    margin-top: 0.125rem;
    vertical-align: middle;
  }

  .dropdown-menu li {
    border-bottom: 1px solid #dddddd;

    &:first-child {
      border: none;
    }

    a {
      font-size: 1rem !important;
      font-size: $font-size-base !important;

      &:hover {
        color: $gray-900 !important;
      }
    }

    &:hover {
      color: $gray-900 !important;
    }

    @media screen and (min-width: 1024px) {
      border: none;
    }
  }

  .toggle-role {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 32px;

    .icon-switch {
      width: 24px;
      margin-right: 8px;
    }
  }

  @media screen and (min-width: 1024px) {
    &.show,
    &:hover {
      .avatar {
        box-shadow: 0 0 0 2px #51b67e;
        transition: box-shadow 120ms ease-out;
      }
    }
  }
}
</style>
